module.exports = __webpack_public_path__ + "static/media/w3af-logo.f3f2ec54.png";